import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight } from "lucide-react";
import { TikTokIcon } from "./icons";
import { AMAZON_STORE, INSTAGRAM_URL, INSTAGRAM_HANDLE, TIKTOK_URL } from "../../data/site";

export const Footer = () => (
  <footer className="bg-champagne/60 border-t border-black/5" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <span className="font-serif text-4xl tracking-[0.18em] uppercase">Fashiella</span>
          <p className="mt-6 max-w-sm text-charcoal/60 leading-relaxed">
            Beautifully crafted hair accessories inspired by timeless moments and everyday elegance.
            Created with love, designed for you.
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <p className="text-xs uppercase tracking-[0.3em] text-charcoal/40 mb-6">Explore</p>
          <ul className="space-y-3">
            {[
              { to: "/", label: "Home" },
              { to: "/catalogue", label: "Catalogue" },
              { to: "/our-story", label: "Our Story" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-charcoal/70 hover:text-charcoal transition-colors duration-300"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.3em] text-charcoal/40 mb-6">Discover</p>
          <ul className="space-y-3">
            <li>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="inline-flex items-center gap-2 text-charcoal/70 hover:text-charcoal transition-colors duration-300"
              >
                <Instagram size={16} /> {INSTAGRAM_HANDLE}
              </a>
            </li>
            <li>
              <a
                href={TIKTOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-tiktok-link"
                className="inline-flex items-center gap-2 text-charcoal/70 hover:text-charcoal transition-colors duration-300"
              >
                <TikTokIcon size={15} /> {INSTAGRAM_HANDLE}
              </a>
            </li>
            <li>
              <a
                href={AMAZON_STORE}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-amazon-link"
                className="inline-flex items-center gap-1 text-charcoal/70 hover:text-charcoal transition-colors duration-300"
              >
                Amazon Store <ArrowUpRight size={15} />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-black/5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs tracking-wide text-charcoal/40">© 2026 Fashiella. All rights reserved.</p>
        <p className="text-xs uppercase tracking-[0.3em] text-charcoal/40">Created with love</p>
      </div>
    </div>
  </footer>
);
